(ns ui.window
  (:require [re-frame.core :as rf]))

(rf/reg-sub
 ::window-size
 (fn [db]
   (get db ::window-size)))

(rf/reg-event-fx
 ::on-window-resize
 (fn [{db :db} _]
   (let [height (.-innerHeight js/window)
         width (.-innerWidth js/window)]
     {:db (assoc db ::window-size {:width  width
                                   :height height})})))

(rf/reg-event-fx
 ::track-window-size
 (fn [{db :db} [_]]
   (let [size-listener (get db ::size-listener)]
     (when-not size-listener
       {:db (assoc db ::size-listener (.addEventListener js/window "resize" #(rf/dispatch [::on-window-resize])))
        :fx [[:dispatch [::on-window-resize]]]}))))
